import EmailNotificationBaseService from 'services/notification/subServices/email/EmailNotificationBaseService';

import RememberPassEmailNotification from 'models/notification/email/RememberPassEmailNotification';

export default class RememberPassEmailNotificationService extends EmailNotificationBaseService {
	toModel(notification) {
		return new RememberPassEmailNotification(notification);
	}
}
